/**
 * ADVARSLENE I SVARET PÅ EN SKRIVING (AI-ANALYSE §8.1 #5 og #6, prinsipp 6: «dobbeltbooking gir en
 * advarsel»).
 *
 * Dobbeltbookingen og «ressursen passer ikke» ble regnet bare i nettsiden (ShiftAssignModal,
 * CrewAssignModal, resources/candidate.ts). En AI-klient eller mobilappen som satte en person på en
 * vakt fikk ingen beskjed. Nå svarer API-et med `warnings` på de rutene som kan dobbeltbooke — en
 * advarsel, aldri en sperre: skrivingen er gjort.
 *
 * Kodene er konfliktlistas regler (`CONFLICT_RULES`, samme navn og samme betydning — testen ved siden
 * av holder dem i takt) pluss de to som gjelder én reservasjon alene.
 */
import { z } from 'zod';

export const WRITE_WARNING_CODES = [
  'exclusive_overlap',
  'exclusive_size',
  'shared_capacity',
  'shared_night',
  'person_double_booked',
  'stage_double_booked',
  'stage_occupied',
  'person_two_places',
  /* Bedt om mer enn ressursen rommer (`size`): ni seter i en bil, tolv som skal med. */
  'resource_too_small',
  /* Reservasjonen føres på en avdeling ressursen ikke hører til. En opplysning, ikke en regel. */
  'resource_other_department',
] as const;
export type WriteWarningCode = (typeof WRITE_WARNING_CODES)[number];

export const writeWarningDtoSchema = z
  .object({
    code: z.enum(WRITE_WARNING_CODES),
    resourceId: z.uuid().nullable(),
    personId: z.uuid().nullable(),
    from: z.iso.datetime().nullable(),
    to: z.iso.datetime().nullable(),
    allocationIds: z.array(z.uuid()),
    shiftIds: z.array(z.uuid()),
  })
  .meta({ id: 'WriteWarning' });
export type WriteWarningDto = z.infer<typeof writeWarningDtoSchema>;

/** Feltet på svaret. Valgfritt: lister og lesinger har det ikke, bare skrivingene som kan dobbeltbooke. */
export const writeWarningsField = z.array(writeWarningDtoSchema).optional();
